import {CharStreams, CommonTokenStream} from 'antlr4';

import RestrictionsParser from './antlr4/RestrictionsParser.js';
import RestrictionsLexer from './antlr4/RestrictionsLexer.js';
import {Hiccup} from './types.js';
import visitor from './visitor.js';

export function parse(input: string): Hiccup {
    const chars = CharStreams.fromString(input);
    const lexer = new RestrictionsLexer(chars);
    const tokens = new CommonTokenStream(lexer);
    const parser = new RestrictionsParser(tokens);
    const tree = parser.parse();
    // todo validate
    return tree.accept(visitor) as Hiccup;
}

interface Visitor {
    and: (lhs, rhs) => boolean
    or: (lhs, rhs) => boolean
    eq: (lhs, rhs) => boolean
    neq: (lhs, rhs) => boolean
    match: (lhs, rhs) => boolean
    str: (x) => string
    number: (x) => number
    expr: (x) => Hiccup<Omit<keyof Visitor, 'expr'>>
    "own-ident": ([_, idn]) => unknown
    ident: ([_, idn]) => unknown
}

function hiccupTransform(visitor: Visitor, tree): unknown {
    if (Array.isArray(tree)) {
        const [first, ...next] = tree;
        const transform = visitor[first];
        if (transform) {
            const args = next.map((x) => hiccupTransform(visitor, x));
            return transform.apply(visitor, args);
        }
        const rest = next.map((x) => hiccupTransform(visitor, x));
        return [first].concat(rest);
    }
    return tree;
}

export function check(restrictions: Readonly<undefined | Hiccup>, ownContext, context) {
    if ((restrictions?.length ?? 0) > 0) {
        return hiccupTransform({
            and: (rhs, lhs) => {
                return rhs && lhs;
            },
            or: (rhs, lhs) => {
                return rhs || lhs;
            },
            eq: (rhs, lhs) => {
                return rhs === lhs;
            },
            neq: (rhs, lhs) => {
                return rhs !== lhs;
            },
            match: (lhs, rhs) => {
                if (rhs && lhs) {
                    return new RegExp(rhs).test(lhs);
                }
                return lhs;
            },
            str(x) {
                return x;
            },
            number: (x) => {
                return JSON.parse(x);
            },
            expr: (x) => {
                return x;
            },
            "own-ident": ([_, idn]) => {
                return ownContext[idn];
            },
            ident([_, idn]) {
                return context[idn];
            },
        }, restrictions as Hiccup<keyof Visitor>);
    } else {
        return true;
    }
}
